import { render, staticRenderFns } from "./MessagesChart.vue?vue&type=template&id=4f0c7714&scoped=true"
import script from "./MessagesChart.vue?vue&type=script&lang=js"
export * from "./MessagesChart.vue?vue&type=script&lang=js"
import style0 from "./MessagesChart.vue?vue&type=style&index=0&id=4f0c7714&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0c7714",
  null
  
)

export default component.exports